import { render, staticRenderFns } from "./assemble_edit.vue?vue&type=template&id=236a0114&scoped=true"
import script from "./assemble_edit.vue?vue&type=script&lang=js"
export * from "./assemble_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a0114",
  null
  
)

export default component.exports